import { SwitchWrapper } from './SwitchWrapper';

// TODO: in v9, move styled() from SwitchWrapper.jsx to here
export var StyledSwitchWrapper = SwitchWrapper;